module.exports = __webpack_public_path__ + "fonts/iconfont.1c7afa50.ttf";